import { isShallowEqual } from "@suse-o11y/is-shallow-equal";
import { Signal } from "@suse-o11y/signal";
import { useEffect } from "@suse-o11y/use-effect";
import { type QueryKey, hashQueryKey } from "react-query";

import { useQueryScopeContext } from "./context";

function useRegisterQueries(keys: ReadonlyArray<QueryKey>): void {
	const registry = useQueryScopeContext();

	const hashed = keys.map(hashQueryKey);

	useEffect(
		() => {
			registry.write((map) =>
				hashed.reduce(
					(acc, hash) =>
						acc.update(hash, (current) => {
							if (current == null) {
								return Signal(1);
							}

							current.write((x) => x + 1);

							return current;
						}),
					map,
				),
			);

			return () => {
				registry.write((map, monitor) =>
					hashed.reduce(
						(acc, hash) =>
							acc.update(hash, (current) => {
								if (current == null || current.read(monitor) === 1) {
									return undefined;
								}

								current.write((x) => x - 1);

								return current;
							}),
						map,
					),
				);
			};
		},
		[hashed, registry],
		[isShallowEqual],
	);
}

export { useRegisterQueries };
